import styled from 'styled-components'
import { LoginButton } from './LoginButton'
import { pluralize } from 'utils/formatting'

interface Props {
  onSubmit: () => Promise<void>
  countdown: number
}

export const ResendLinkButton = ({ onSubmit, countdown }: Props) => {
  return (
    <Wrapper>
      <LoginButton disabled={countdown > 0} view="secondary" onClick={onSubmit}>
        Request a new link {countdown > 0 && ` in ${countdown} ${pluralize('second', countdown)}`}
      </LoginButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 8px;
`
